import { createComponentWrapperWithRef, ListItemIcon, styled } from '@msdk/ui'

const StyledSidebarListItemIcon = styled(ListItemIcon)`
  color: inherit;
  min-width: unset;
  padding-right: 0;
`

const NovaStyledSidebarListItemIcon = styled(StyledSidebarListItemIcon)`
  padding: 0;
`

export const SidebarListItemIcon = createComponentWrapperWithRef(
  {
    mui: StyledSidebarListItemIcon,
    nova: NovaStyledSidebarListItemIcon,
  },
  'SidebarListItemIcon',
)
